// 低版本浏览器兼容

// Object.fromEntries
if (!Object.fromEntries) {
  Object.fromEntries = function (entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries requires a single iterable argument')
    }
    const result = {}
    for (const [key, value] of entries) {
      result[key] = value
    }
    return result
  }
}

// matchAll
if (!String.prototype.matchAll) {
  String.prototype.matchAll = function (regexp) {
    var matches = []
    this.replace(regexp, function () {
      var arr = [].slice.call(arguments, 0)
      var extras = arr.splice(-2)
      arr.index = extras[0]
      arr.input = extras[1]
      matches.push(arr)
    })
    return matches.length ? matches : ''
  }
}

// flat
if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth = 1) {
    return this.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) && depth - 1 ? toFlatten.flat(depth - 1) : toFlatten)
    }, [])
  }
}
